// import $axios from '../services/api.js'
import cookie from 'vue-cookie'

const state = () => ({
    postsReadLocal: cookie.get('postsReadLocal') == null 
                    ? [] 
                    : cookie.get('postsReadLocal').split(',').map(postId => parseInt(postId)),
    announcementsReadLocal: cookie.get('announcementsReadLocal') == null 
                    ? [] 
                    : cookie.get('announcementsReadLocal').split(',').map(announcementId => parseInt(announcementId)),
    postReadAllLocal: cookie.get('postsReadAllLocal') == null 
                    ? 0 
                    : parseInt(cookie.get('postsReadAllLocal')),
    eventsReadLocal: cookie.get('eventsReadLocal') == null 
                    ? [] 
                    : cookie.get('eventsReadLocal').split(',').map(eventId => parseInt(eventId)),
})

const mutations = {
    ASSIGN_POST_READ_LOCAL(state, payload) {
        state.postsReadLocal.push(payload)
        cookie.set('postsReadLocal', state.postsReadLocal)
    },
    ASSIGN_POST_READ_ALL_LOCAL(state, payload) {
        state.postsReadAllLocal = payload
        cookie.set('postsReadAllLocal', state.postsReadAllLocal)
    },
    ASSIGN_ANNOUNCEMENT_READ_LOCAL(state, payload) {
        state.announcementsReadLocal.push(payload)
        cookie.set('announcementsReadLocal', state.announcementsReadLocal)
    },
    ASSIGN_EVENT_READ_LOCAL(state, payload) {
        state.eventsReadLocal = state.eventsReadLocal.concat(payload)
        cookie.set('eventsReadLocal', state.eventsReadLocal)
    },
}

const actions = {
    readPostNotificaion({ commit, state }, postId) {
        if(!state.postsReadLocal.includes(postId)){
            commit('ASSIGN_POST_READ_LOCAL', postId)
        }
    },
    readAllPostNotificaion({ commit, state }, total) {
        commit('ASSIGN_POST_READ_ALL_LOCAL', total)
    },
    readAnnouncementNotificaion({ commit }, announcementId) {
        commit('ASSIGN_ANNOUNCEMENT_READ_LOCAL', announcementId)
    },
    readEventNotificaion({ commit, state }, arrEventId) {
        let tempArrEventId = arrEventId.filter((eventId) => {
                                if (!state.eventsReadLocal.includes(eventId)) {
                                    return eventId
                                }
                            })
        if (tempArrEventId.length > 0) {
            commit('ASSIGN_EVENT_READ_LOCAL', tempArrEventId)
        }
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}